import { Typography } from "@mui/material";
import type { MouseEvent } from "react";
import MarkdownPreview from "@entrilia/shared/components/markdown/MarkdownPreview";
import { useIntercomContext } from "@entrilia/shared/contexts/IntercomContext";
import type { ChatItem } from "../chatState";
import { getHelpArticleId } from "./helpArticleLink";

interface Props {
  item: ChatItem;
}

const isChatFileLink = (href: string) => /^sandbox:/i.test(href);

const ChatMessageText = ({ item }: Props) => {
  const { getArticleUrl, showArticle } = useIntercomContext();

  const handleAnswerClick = (event: MouseEvent<HTMLDivElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }

    const anchor = event.nativeEvent.composedPath().find((target) => target instanceof HTMLAnchorElement);
    const articleId = anchor && getHelpArticleId(anchor.href, new URL(getArticleUrl("0")).origin);
    if (!articleId) {
      return;
    }

    event.preventDefault();
    showArticle(articleId);
  };

  if (!item.messageText) {
    return null;
  }

  if (item.source === "user") {
    return <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{item.messageText}</Typography>;
  }

  return (
    <MarkdownPreview
      content={item.messageText}
      openLinksInNewTab
      withoutImages
      webLinksOnly
      isLinkHidden={isChatFileLink}
      containerProps={{ sx: { overflowX: "auto" }, onClick: handleAnswerClick }}
    />
  );
};

export default ChatMessageText;
